import actionTypes from '../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.plansPage.set,
  data,
});

export const getAccountIdAction = (data) => ({
  type: actionTypes.plansPage.getAccountId,
  data,
});

export const getTeamPlansAction = (data) => ({
  type: actionTypes.plansPage.getTeamPlans,
  data,
});

export const getPlansAction = (data) => ({
  type: actionTypes.plansPage.getPlans,
  data,
});

export const getCouponAction = (data) => ({
  type: actionTypes.plansPage.getCoupon,
  data,
});

export const deletePlanAction = (data) => ({
  type: actionTypes.plansPage.deletePlan,
  data,
});

export const updatePlanAction = (data) => ({
  type: actionTypes.plansPage.updatePlan,
  data,
});
